module.exports = __webpack_public_path__ + "img/SAP_8968p_l.c4db8c21.jpg";